/*
 *  TTTech nerve-management-system-frontend
 *  Copyright(c) 2026. TTTech Industrial Automation AG.
 *
 *  ALL RIGHTS RESERVED.
 *
 *  Usage of this software, including source code, netlists, documentation,
 *  is subject to restrictions and conditions of the applicable license
 *  agreement with TTTech Industrial Automation AG or its affiliates.
 *
 *  All trademarks used are the property of their respective owners.
 *
 *  TTTech Industrial Automation AG and its affiliates do not assume any liability
 *  arising out of the application or use of any product described or shown
 *  herein. TTTech Industrial Automation AG and its affiliates reserve the right to
 *  make changes, at any time, in order to improve reliability, function or
 *  design.
 *
 *  Contact Information:
 *  support@tttech-industrial.com
 *
 *  TTTech Industrial Automation AG, Schoenbrunnerstrasse 7, 1040 Vienna, Austria
 *
 */

import BaseApiService from './base.api-service';

const ENDPOINTS = {
  ACCESS_TOKENS: '/crm/v1/access-tokens',
};

class AccessTokensApiService extends BaseApiService {
  async getAccessTokens() {
    const response = await this.get(ENDPOINTS.ACCESS_TOKENS, {
      authRequired: true,
    });

    return response.accessTokens || [];
  }

  revokeAccessToken(tokenId) {
    return this.patch(`${ENDPOINTS.ACCESS_TOKENS}/${tokenId}`, {}, { authRequired: true });
  }

  deleteAccessToken(tokenId) {
    return this.delete(`${ENDPOINTS.ACCESS_TOKENS}/${tokenId}`, { authRequired: true });
  }

  generateAccessToken(name, expirationDate, permissions) {
    return this.post(ENDPOINTS.ACCESS_TOKENS, { name, expirationDate, permissions }, { authRequired: true });
  }
}

export default new AccessTokensApiService();
